export default __webpack_public_path__ + "static/media/Star logo Black.c26ebc4d.png";